const Title = ({text}) => {
    return (
        <h1 className="display-4">{text}</h1>
    )
}

export default Title;